<template>
  <div class="login-modal-overlay">
    <div class="login-modal-container" @click.stop>

      <!-- 模态框内容 -->
      <div class="login-modal-content">
        <!-- 左侧装饰 -->
        <div class="modal-left">
          <div class="welcome-text">
            <h1>{{ isLogin ? '欢迎回来' : '创建账户' }}</h1>
            <p>{{ isLogin ? '登录您的账户以继续' : '加入我们开始您的旅程' }}</p>
          </div>
          
          <!-- 品牌Logo区域 - 更大尺寸 -->
          <div class="brand-logo-container">
            <svg width="280" height="140" viewBox="0 0 960 300" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="title desc">
              <title id="title">印记云（YinJiYun）在线 Markdown 编辑器 Logo</title>
              <desc id="desc">一个由浅紫与白色构成的云形图标，云中融入纸张与书签笔记元素，右侧为"印记云"字标，整体简洁易辨识，表达随时在云端记录的品牌理念。</desc>

              <!-- 调色板 -->
              <defs>
                <!-- 主渐变（浅紫） -->
                <linearGradient id="gPrimary" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stop-color="#EDE9FE"/>
                  <stop offset="100%" stop-color="#A78BFA"/>
                </linearGradient>

                <!-- 高光渐变 -->
                <linearGradient id="gSheen" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.9"/>
                  <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0"/>
                </linearGradient>

                <!-- 柔和阴影 -->
                <filter id="softShadow" x="-20%" y="-20%" width="140%" height="160%" color-interpolation-filters="sRGB">
                  <feDropShadow dx="0" dy="8" stdDeviation="16" flood-color="#7C3AED" flood-opacity="0.15"/>
                </filter>

                <!-- 图标符号（仅图形，不带文字，可独立使用为 App 图标 / Favicon 轮廓） -->
                <symbol id="logoIcon" viewBox="0 0 256 256">
                  <!-- 云主体 -->
                  <g filter="url(#softShadow)">
                    <path d="M174 108c-3.8-24.6-25.4-44-51.6-44-22.3 0-41.4 13.8-48.8 33.1-22.3 1.7-39.6 20.3-39.6 42.9 0 23.8 19.3 43.1 43.1 43.1h111.2c22.2 0 40.3-18 40.3-40.3 0-21.2-16.3-38.6-36.9-40.8z"
                        fill="url(#gPrimary)"/>
                    <!-- 云高光 -->
                    <path d="M66 136c0-22 18-40 40-40 10 0 19 3 26.5 8.5 7.5 5.5 17 8.5 26.5 8.5 19 0 35-12 40-28 9 6 15 16 15 28 0 20-17 36-38 36H90c-13.3 0-24-10.7-24-24z"
                          fill="url(#gSheen)" opacity="0.35"/>
                  </g>

                  <!-- 内嵌"笔记"页面（白底卡片，右上折角） -->
                  <g transform="translate(76,86)">
                    <!-- 卡片 -->
                    <path d="M0 18c0-9.94 8.06-18 18-18h60c4.24 0 8.31 1.68 11.31 4.69L110 21.38V96c0 9.94-8.06 18-18 18H18c-9.94 0-18-8.06-18-18V18z"
                          fill="#FFFFFF"/>
                    <!-- 折角 -->
                    <path d="M89 0l21 21h-13c-4.42 0-8-3.58-8-8V0z" fill="#EDE9FE" />
                    <!-- 书签（"印记"象征） -->
                    <path d="M24 18h20c2.21 0 4 1.79 4 4v54l-14-8-14 8V22c0-2.21 1.79-4 4-4z"
                          fill="#8B5CF6"/>
                    <!-- 三条简笔记线 -->
                    <rect x="52" y="32" width="44" height="6" rx="3" fill="#C4B5FD"/>
                    <rect x="52" y="52" width="44" height="6" rx="3" fill="#D9D6FE"/>
                    <rect x="52" y="72" width="34" height="6" rx="3" fill="#E5E1FF"/>
                    <!-- 小闪光：灵感/快速记录 -->
                    <circle cx="100" cy="16" r="6" fill="#FFFFFF" opacity="0.9"/>
                  </g>

                  <!-- 轻描边强化边界 -->
                  <path d="M174 108c-3.8-24.6-25.4-44-51.6-44-22.3 0-41.4 13.8-48.8 33.1-22.3 1.7-39.6 20.3-39.6 42.9 0 23.8 19.3 43.1 43.1 43.1h111.2c22.2 0 40.3-18 40.3-40.3 0-21.2-16.3-38.6-36.9-40.8z"
                        fill="none" stroke="#C4B5FD" stroke-opacity="0.6" stroke-width="2"/>
                </symbol>
                <!-- 字标（使用系统中文无衬线字体族，便于跨平台显示） -->
                <symbol id="logoWordmark" viewBox="0 0 600 120" preserveAspectRatio="xMidYMid meet">
                  <!-- 左侧分隔细线 -->
                  <rect x="0" y="14" width="2" height="92" fill="#FFFFFF" />
                  <!-- 中文字标 -->
                  <text x="22" y="70"
                        font-family="Noto Sans SC, PingFang SC, Microsoft YaHei, Helvetica Neue, Arial, sans-serif"
                        font-size="70" font-weight="600" letter-spacing="2"
                        fill="#FFFFFF">印记云</text>
                  <!-- 副标题（可选：产品定位） -->
                  <text x="22" y="110"
                        font-family="Noto Sans SC, PingFang SC, Microsoft YaHei, Helvetica Neue, Arial, sans-serif"
                        font-size="30" font-weight="500" letter-spacing="1"
                        fill="#FFFFFF">在线 Markdown · 云端速记</text>
                </symbol>
              </defs>

              <!-- 组合：横向锁定 -->
              <g transform="translate(60,40)">
                <use href="#logoIcon" width="220" height="220" />
                <g transform="translate(260, 50)">
                  <use href="#logoWordmark" width="600" height="120"/>
                </g>
              </g>
            </svg>
          </div>
          
          <!-- 保留的浮动图标 -->
          <div class="floating-icons">
            <div class="icon icon-1">🔒</div>
            <div class="icon icon-2">👤</div>
            <div class="icon icon-3">✨</div>
          </div>
        </div>

        <!-- 右侧表单 -->
        <div class="modal-right">
          <!-- 切换按钮 -->
          <div class="toggle-buttons">
            <button 
              :class="['toggle-btn', { active: isLogin }]" 
              @click="switchToLogin"
            >
              登录
            </button>
            <button 
              :class="['toggle-btn', { active: !isLogin }]" 
              @click="switchToRegister"
            >
              注册
            </button>
          </div>

          <!-- 登录表单 -->
          <div v-if="isLogin" class="form-container">
            <form class="login-form" @submit.prevent="handleLogin">
              <!-- 邮箱输入框 -->
              <div class="form-group">
                <label for="login-email">邮箱</label>
                <el-input
                  id="login-email"
                  v-model="loginForm.email"
                  placeholder="请输入邮箱"
                  prefix-icon="el-icon-message"
                  clearable
                ></el-input>
              </div>

              <!-- 密码输入框 -->
              <div class="form-group">
                <label for="login-password">密码</label>
                <el-input
                  id="login-password"
                  v-model="loginForm.password"
                  type="password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                ></el-input>
              </div>

              <button
                type="submit"
                class="submit-button"
                :disabled="loading"
              >
                <span v-if="loading" class="loading-spinner"></span>
                {{ loading ? '登录中...' : '登录' }}
              </button>
            </form>
          </div>

          <!-- 注册表单 -->
          <div v-else class="form-container">
            <form  @submit.prevent="handleRegister">
              <!-- 邮箱输入框 -->
              <div class="form-group">
                <label for="register-email">邮箱</label>
                <el-input
                  id="register-email"
                  v-model="registerForm.email"
                  type="email"
                  placeholder="请输入邮箱"
                  prefix-icon="el-icon-message"
                  clearable
                ></el-input>
              </div>

              <!-- 验证码输入框和发送按钮 -->
              <div class="form-group">
                <label for="register-verification-code">验证码</label>
                <div class="input-with-button">
                  <el-input
                    id="register-verification-code"
                    v-model="registerForm.verificationCode"
                    placeholder="请输入邮箱验证码"
                    prefix-icon="el-icon-key"
                    clearable
                    maxlength="6"
                  ></el-input>
                  <el-button 
                    type="primary" 
                    size="small"
                    @click="sendVerificationCode"
                    :disabled="sendingCode || !isValidEmail(registerForm.email) || countdown > 0"
                    :loading="sendingCode"
                    class="verification-code-btn"
                  >
                    {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
                  </el-button>
                </div>
              </div>

              <!-- 密码输入框 -->
              <div class="form-group">
                <label for="register-password">密码</label>
                <el-input
                  id="register-password"
                  v-model="registerForm.password"
                  type="password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                  minlength="6"
                ></el-input>
              </div>

              <!-- 确认密码输入框 -->
              <div class="form-group">
                <label for="register-confirm-password">确认密码</label>
                <el-input
                  id="register-confirm-password"
                  v-model="registerForm.confirmPassword"
                  type="password"
                  placeholder="请再次输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                ></el-input>
              </div>

              <button
                type="submit"
                class="submit-button"
                :disabled="loading"
              >
                <span v-if="loading" class="loading-spinner"></span>
                {{ loading ? '注册中...' : '注册' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { user_register_path, 
         user_login_path, 
         user_send_code_path,
         file_list_path} from '@/js/api_paths';
export default {
  name: 'LoginModal',
  
  data() {
    return {
      isLogin: true,
      loading: false,
      sendingCode: false,
      countdown: 0,
      countdownTimer: null,
      
      loginForm: {
        email: '',
        password: '',
        remember: false
      },
      
      registerForm: {
        username: '',
        email: '',
        verificationCode: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false
      }
    }
  },

  created(){
    const token = localStorage.getItem("token");
    const username = localStorage.getItem("username");
    const email = localStorage.getItem("email");
    if (token) { // 检查token是否过期
      let req = {
        "relative_dir": '/'
      };
      fetch(file_list_path, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if(data.status == "success"){
          this.$store.commit("SET_TOKEN", token);
          this.$store.commit("SET_USERNAME", username);
          this.$store.commit('SET_EMAIL', email);
          this.$store.commit("SET_IS_LOGIN", true);
          this.$router.push('/Editor'); // 如果是登录状态则直接进到编辑器页面
        }
      })
      .catch(error => {
        console.log(error);
      })
    }
    
  },

  mounted(){
  },

  computed : {
  },

  beforeDestroy() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  
  methods: {
    switchToLogin() {
      this.isLogin = true
      this.resetForms()
    },
    
    switchToRegister() {
      this.isLogin = false
      this.resetForms()
    },
    
    resetForms() {
      this.loginForm = {
        email: '',
        password: '',
        remember: false
      }
      
      this.registerForm = {
        username: '',
        email: '',
        verificationCode: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false
      }
      
      this.loading = false
      this.sendingCode = false
      
      // 清理倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
    
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return email && emailRegex.test(email);
    },
    
    async sendVerificationCode() {
      if (!this.registerForm.email) {
        this.$message?.error('请输入邮箱地址');
        return;
      }
      
      if (!this.isValidEmail(this.registerForm.email)) {
        this.$message?.error('请输入有效的邮箱地址');
        return;
      }
      
      this.sendingCode = true;
      
      try {
        const response = await fetch(user_send_code_path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: this.registerForm.email
          })
        });
        
        const data = await response.json();
        
        if (data.status === 'success') {
          this.$message?.success('验证码已发送至您的邮箱');
          this.startCountdown();
        } else {
          this.$message?.error(data.msg || '发送验证码失败');
        }
      } catch (error) {
        this.$message?.error('发送验证码失败，请稍后重试');
      } finally {
        this.sendingCode = false;
      }
    },
    
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    
    async handleLogin() {
      if (!this.loginForm.email || !this.loginForm.password) {
        this.$message?.error('请输入邮箱和密码')
        return
      }
      
      this.loading = true;
      
      try {
        let req = {
          "email": this.loginForm.email,
          "password": this.loginForm.password
        };
        fetch(user_login_path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(req)
        })
        .then((res) =>{
          return res.json();
        })
        .then((data) => {
          if(data.status == "success"){
            let msg = data.msg;
            // 登录成功
            this.$emit('login-success', {
              username: this.loginForm.username,
              remember: this.loginForm.remember
            })
            this.$store.commit("SET_TOKEN", msg.jwt_token);
            this.$store.commit("SET_USERNAME", msg.username);
            this.$store.commit("SET_IS_LOGIN", true);
            this.$store.commit("SET_EMAIL", this.loginForm.email);

            localStorage.setItem("email", this.loginForm.email);
            localStorage.setItem("token", msg.jwt_token); // 将token存储在本地
            localStorage.setItem("username", msg.username); // 将username存储在本地

            this.$router.push('/Editor'); // 跳转到编辑器页面
          }
          else{
            this.$message?.error(data.msg);
          }
          
        })
        
      } catch (error) {
        this.$message?.error('登录失败，请检查用户名和密码')
      } finally {
        this.loading = false
      }
    },
    
    async handleRegister() {
      // 表单验证
      if (!this.registerForm.email || 
          !this.registerForm.password || !this.registerForm.confirmPassword) {
        this.$message?.error('请填写所有必填字段');
        return;
      }
      
      if (!this.registerForm.verificationCode) {
        this.$message?.error('请输入验证码');
        return;
      }
      
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.$message?.error('两次输入的密码不一致')
        return
      }
      
      if (this.registerForm.password.length < 6) {
        this.$message?.error('密码长度至少6位')
        return
      }
      
      this.loading = true;
      
      try {
        let req = {
          "email": this.registerForm.email,
          "password": this.registerForm.password,
          "verification_code": this.registerForm.verificationCode
        };
        
        const response = await fetch(user_register_path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(req)
        });
        
        const data = await response.json();
        
        if (data.status === 'success') {
          this.$message?.success('注册成功');
          this.$emit('register-success', {
            username: this.registerForm.username,
            email: this.registerForm.email
          });
          this.switchToLogin();
        } else {
          this.$message?.error(data.msg || '注册失败，请稍后重试');
        }
      } catch (error) {
        this.$message?.error('注册失败，请稍后重试');
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.7) 0%, rgba(201, 175, 227, 0.7) 100%);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.login-modal-container {
  position: relative;
  width: 900px;
  height: 650px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.4s ease-out;
}

.login-modal-content {
  display: flex;
  height: 100%;
}

.modal-left {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.modal-right {
  flex: 1;
  background: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 品牌Logo容器 - 更大尺寸 - 透明背景 */
.brand-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  background: transparent;
  border: none;
  border-radius: 0;
  backdrop-filter: none;
  margin-top: 20px;
  margin-bottom: 30px;
}

/* 调整SVG大小 */
.brand-logo-container svg {
  max-width: 100%;
  height: auto;
  transform: scale(1.2); /* 放大20% */
}

/* 表单容器 - 添加滚动条 */
.form-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.toggle-buttons {
  display: flex;
  background: #f5f5f5;
  border-radius: 25px;
  padding: 5px;
  margin-bottom: 30px;
  flex-shrink: 0;
}

.toggle-btn {
  flex: 1;
  border: none;
  background: transparent;
  padding: 12px;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-btn.active {
  background: #667eea;
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

/* 输入框和按钮组合样式 */
.input-with-button {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input-with-button .el-input {
  flex: 1;
}

/* Element UI el-input 样式微调 */
:deep(.el-input__inner) {
  padding-left: 40px !important;
  padding-right: 40px !important;
  border: 2px solid #e1e5e9 !important;
  border-radius: 12px !important;
  background: #f8f9fa !important;
  transition: all 0.3s ease;
  height: 52px;
}

:deep(.el-input__inner:focus) {
  border-color: #667eea !important;
  background: white !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

/* 验证码按钮样式优化 */
.verification-code-btn {
  height: 52px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 0 20px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3) !important;
  min-width: 120px;
  white-space: nowrap;
}

.verification-code-btn:hover:not(:disabled) {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
}

.verification-code-btn:disabled {
  opacity: 0.6 !important;
  background: #f0f0f0 !important;
  color: #999 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.submit-button {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-top: 10px;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-right: 10px;
}

.welcome-text h1 {
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.welcome-text p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  line-height: 1.6;
}

/* 图标动画相关样式 */
.floating-icons {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.icon {
  position: absolute;
  font-size: 2rem;
  opacity: 0.1;
  animation: float 6s ease-in-out infinite;
}

.icon-1 {
  top: 30%;
  left: 10%;
  animation-delay: 0s;
}

.icon-2 {
  top: 70%;
  right: 15%;
  animation-delay: 2s;
}

.icon-3 {
  bottom: 40%;
  left: 20%;
  animation-delay: 4s;
}

/* 动画关键帧 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 图标浮动动画 */
@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(10deg);
  }
}

/* 旋转动画（可选） */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 992px) {
  .login-modal-container {
    width: 95%;
    height: auto;
    max-height: 95vh;
  }
  
  .login-modal-content {
    flex-direction: column;
  }
  
  .modal-left {
    padding: 30px 20px;
  }
  
  .modal-right {
    padding: 30px 20px;
  }
  
  .welcome-text h1 {
    font-size: 2rem;
  }
  
  .input-with-button {
    flex-direction: column;
    align-items: stretch;
  }
  
  .verification-code-btn {
    min-width: 100px;
    padding: 0 15px !important;
    font-size: 14px;
  }
  
  .brand-logo-container {
    margin-top: 15px;
    margin-bottom: 20px;
    padding: 20px;
  }
  
  .brand-logo-container svg {
    max-width: 95%;
    transform: scale(1.1);
  }
}

@media (max-width: 576px) {
  .input-with-button {
    flex-direction: column;
  }
  
  .welcome-text h1 {
    font-size: 1.8rem;
  }
  
  .welcome-text p {
    font-size: 1rem;
  }
  
  .brand-logo-container svg {
    transform: scale(1);
  }
}
</style>